/* eslint-disable react-hooks/exhaustive-deps */
import Listado from 'components/public/Listado/Listado';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { titulosListadoBoletines } from 'utils/constants';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import Spinner from 'components/public/Spinner/Spinner';
import { Boletin } from 'utils/models/types';
import { fetchBoletines } from 'utils/redux/features/boletinesSlice';
import { formatearDateAFechaHoraUY, limitarTexto } from 'utils/utilities';

const Boletines = () => {
  const { boletines, loadingBoletines, errorBoletines } = useSelector((state: RootState) => state.boletines);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchBoletines());
  }, [dispatch]);

  const error401 = errorBoletines?.includes('permisos');

  const boletinesListado: Boletin[] = boletines.map((b: Boletin) => {
    const fechaEnviado = new Date(b.FechaEnviado);
    return {
      Id: b.Id,
      NombreEnviador: b.NombreEnviador,
      Asunto: b.Asunto,
      Titulo: b.Titulo ? b.Titulo : '-',
      Body: b.Body ? limitarTexto(b.Body, 50) : '-',
      ImagenUrl: b.ImagenUrl,
      FechaEnviado: fechaEnviado ? formatearDateAFechaHoraUY(fechaEnviado) : 'Sin fecha',
    };
  });

  return loadingBoletines ? (
    <Spinner />
  ) : errorBoletines ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={boletinesListado}
      headCells={titulosListadoBoletines}
      titulo="Boletines enviados"
      loading={loadingBoletines}
    />
  );
};

export default Boletines;
